import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AdminOverlay from './components/AdminOverlay';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './contexts/AuthContext';
import { LaunchProvider } from './contexts/LaunchContext';
import About from './pages/About';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Cookies from './pages/Cookies';
import ExpoApp from './pages/ExpoApp';
import FAQ from './pages/FAQ';
import Features from './pages/Features';
import Home from './pages/Home';
import LoginPage from './pages/LoginPage';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './styles/App.css';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <LaunchProvider>
        <Router>
          <ScrollToTop />
          <div className="app">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/features" element={<Features />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin-login" element={<AdminLogin />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/app" element={<ExpoApp />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/cookies" element={<Cookies />} />
            </Routes>
            <Footer />
            <AdminOverlay />
          </div>
        </Router>
        </LaunchProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;